export default __webpack_public_path__ + "static/media/close-icon.ea7c95d7.svg";